interface IconExpandProps {
  expanded?: boolean;
}

const IconExpand: FC<IconExpandProps> = ({ expanded = false }) => {
  return (
    <svg className='h-3 w-3' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
        d={`${expanded ? 'M19 9l-7 7-7-7' : 'M9 5l7 7-7 7'}`}
      />
    </svg>
  );
};

export default IconExpand;
